import {
    PaymentElement,
    useElements,
    useStripe
} from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopUpAlert from '../../component/PopUpAlert';
import Loader from "../../component/Loader";
import confetti from "canvas-confetti";

const SubscriptionForm = ({ stateObj, userInStore }) => {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [message, setMessage] = useState({ type: '', content: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const fireworksAnimation = () => {
        var duration = 4 * 1000;
        var animationEnd = Date.now() + duration;
        var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

        function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
        }

        var interval = setInterval(function () {
            var timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            var particleCount = 50 * (timeLeft / duration);
            // since particles fall down, start a bit higher than random
            confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
            confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
        }, 250);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }
        setIsLoading(true);
        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            redirect: "if_required",
            confirmParams: {
                return_url: "",
                payment_method_data: {
                    billing_details: {
                        name: name
                    }
                }
            },
        });

        if (paymentIntent?.status === "succeeded") {
            setMessage({ type: 'success', content: 'Purchased successfully' });
            fireworksAnimation();
            setTimeout(() => {
                navigate("/");
            }, 2000)
        }
        if (paymentIntent?.status === "processing") {
            setMessage({ type: 'warning', content: 'Your payment in processing' })
            setTimeout(() => {
                navigate("/");
            }, 3000)
        }

        if (error != undefined) {
            if (error.type === "card_error" || error.type === "validation_error") {

                setMessage({ type: 'error', content: error.message });
                setIsLoading(false);
            } else {
                setMessage("An unexpected error occurred.");
            }
        }
        setIsLoading(false);
    };



    return (
        <div className="player_subscription_container">
            <form id="payment-form" onSubmit={handleSubmit}>
                {isLoading && <Loader />}
                <PopUpAlert message={message.content} type={message.type} />
                <PaymentElement id="payment-element" />
                <div className="payment_card_holder_name">
                    <label className="payment_card_holder_name_label" htmlFor="cardHolderName">Card holder name</label>
                    <input className="payment_card_holder_name_input" onChange={(e) => setName(e.target.value)} type="text" id="cardHolderName" />
                    <button disabled={isLoading || !stripe || !elements} id="submit">Subscribe</button>
                </div>
            </form>
            {!userInStore?.userInfo?.isFirstSubscription
                ?
                <div className="player_subscription_player_details">
                    <h1>Subscription Details</h1>
                    <div className="player_subscription_detals_row">
                        <p>Subscription Price</p>
                        <p>${(Number(stateObj?.membershipAmount) / 100).toFixed(2)}</p>
                    </div>
                    {stateObj?.processingFee !== '0' &&
                     <div className="player_subscription_detals_row">
                        <p>Subscription Price</p>
                        <p>${Number(stateObj?.processingFee)}</p>
                    </div>}
                    <hr className="reservation_horizontal_line" />
                    <div className="player_subscription_detals_row">
                        <p>Total amount</p>
                        <p>${Number(stateObj?.totalAmount)}</p>
                    </div>
                </div>
                :
                <div className="player_subscription_player_details">
                    <h1>Subscription Details</h1>
                    <div className="player_subscription_detals_row">
                        <p>Subscription Price</p>
                        <p>${stateObj?.totalAmount}</p>
                    </div>
                    <div className="player_subscription_detals_row">
                        <p>One Time Registration Fee<span></span> </p>
                        <p>${(Number(stateObj?.clubActivationFee)).toFixed(2)}</p>
                    </div>
                    {stateObj?.processingFee !== '0' &&
                        <div className="player_subscription_detals_row">
                            <p>Processing Fee</p>
                            <p>${Number(stateObj?.processingFee)}</p>
                        </div>}
                    <hr className="reservation_horizontal_line" />
                    <div className="player_subscription_detals_row">
                        <p>Total amount</p>
                        <p>${((Number(stateObj?.totalAmount)) + Number(stateObj?.clubActivationFee)).toFixed(2)}</p>
                    </div>
                </div>}
        </div>
    );

}

export default SubscriptionForm